// extracted by mini-css-extract-plugin
module.exports = {"MaritalStatus":"index-module_MaritalStatus_wNQzr"};